import axios from "@/common/http";
export default {
  state: () => ({
    currentStep: 1, // 当前步骤
    model_id: 0, // 模特id
    scene_id: 0, // 场景id
    task_type: 0, // 任务类型 0-人台、1-真人
    segmentDone: [], // 分割完成数据
    outfitConfig: {}, // 换装配置
    modalClass: [], // 当前模特下的配置
    extend: {}, // 扩展数据
    images: [], // 用户上传素材图
    ref_images: [], // 用户上传参考
    code: "", // 制作码
    pay_method: 2, // 支付方式 2-支付宝、3-微信
    cprice: "···", // 服装商拍价格
    firstClothing: true, // 是否第一次进入服装商拍
    // 场景列表V2
    sceneList: {},
    scene: null, // 场景V2 id
    desc: "", // 作图备注
    face_id: -1, // 人脸id
  }),
  mutations: {
    setSegmentDone(state, data) {
      state.segmentDone = data;
    },
    setCurrentStep(state, data) {
      state.currentStep = data;
    },
    setOutfitConfig(state, data) {
      state.outfitConfig = data;
    },
    setModelId(state, data) {
      state.model_id = data;
    },
    setModalClass(state, data) {
      state.modalClass = data;
    },
    setSceneId(state, data) {
      state.scene_id = data;
    },
    setTaskType(state, data) {
      state.task_type = data;
    },
    setExtend(state, data) {
      state.extend = data;
    },
    setExtendItem(state, data) {
      state.extend[data.key] = data.value;
    },
    setImages(state, data) {
      state.images = data;
    },
    setRefImages(state, data) {
      state.ref_images = data;
    },
    setCode(state, data) {
      state.code = data;
    },
    setPayMethod(state, data) {
      state.pay_method = data;
    },
    setCprice(state, data) {
      state.cprice = data;
    },
    setFirstClothing(state, data) {
      state.firstClothing = data;
    },
    setSceneList(state, data) {
      state.sceneList = data;
    },
    setScene(state, data) {
      state.scene = data;
    },
    setDesc(state, data) {
      state.desc = data;
    },
    setFaceId(state, data) {
      state.face_id = data;
    },
  },
  actions: {
    // 抠图 - 调用皮卡
    async photoProcess({ commit }, file) {
      console.log(commit);
      const res = await axios.post("/v1/photo/process", file);
      return res;
    },
    // 获取换装配置
    async outfitConfig({ commit }) {
      console.log(commit);
      const res = await axios.get("/v1/outfit/config");
      return res;
    },
    // 图片上传
    async replacementUploadPic({ commit }, file) {
      console.log(commit);
      const res = await axios.post("/v1/upload/pic", file);
      return res;
    },
    // 上传用户历史服装记录
    async historyUpload({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/outfit/history/upload", data);
      return res;
    },
    // 获取用户历史上传服装记录
    async historyList({ commit }, data) {
      console.log(commit);
      const res = await axios.get("/v1/outfit/history/list", {
        params: data,
      });
      return res;
    },
    // 任务提交
    async taskSubmit({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/outfit/task/submit", data);
      return res;
    },
    // 服装商拍任务提交
    async clothingTaskSubmit({ commit, state }) {
      let params = {
        code: state.code,
        ref_images: state.ref_images,
        images: state.images,
        desc: state.desc,
        scene: state.scene,
        face_id: state.face_id,
        // pay_method: state.pay_method,
      };
      console.log(commit);
      const res = await axios.post("/v1/clothing/task/submit", params);
      return { ...res, feParams: params };
    },
    // 兑换制作码
    async clothingTaskCodeSubmit({ commit, state }, parent_task_id) {
      let params = {
        parent_task_id,
        code: state.code,
      };
      console.log(commit);
      const res = await axios.post("/v1/clothing/task/exchange_code", params);
      return res;
    },
    // 积分制作码
    async clothingTaskIntegralSubmit({ commit, state }, parent_task_id) {
      let params = {
        parent_task_id,
      };
      console.log(commit);
      const res = await axios.post("/v1/clothing/task/consume_point", params);
      return res;
    },
    // 任务历史
    async taskList({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/outfit/task/list", data);
      return res;
    },
    // 任务删除
    async taskDelete({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/outfit/task/delete", data);
      return res;
    },
    // 任务状态
    async taskDetail({ commit }, data) {
      console.log(commit);
      const res = await axios.get("/v1/outfit/task/detail", {
        params: data,
      });
      return res;
    },
    // 图片分割 - 本地服务
    async segUpload({ commit }, file) {
      console.log(commit);
      const res = await axios.post(
        "http://10.61.158.24:18002/seg_upload",
        file
      );
      return res;
    },
    // 分割
    async photoSegmentation({ commit }, file) {
      console.log(commit);
      const res = await axios.post("/v1/upload/pic/seg", file);
      return res;
    },
    // 模特场景列表
    async getOutfitModels({ commit, state }) {
      console.log(commit);
      const res = await axios.get("/v1/outfit/models");
      if (res.status === "200") {
        // 提取模型配置
        let models = res.data.models.reduce((acc, item) => {
          const { m_type, ...rest } = item;
          if (rest.type === state.task_type) {
            acc["I" + m_type] = acc["I" + m_type] || [];
            if (rest.phiz_list) {
              rest["list"] = rest.phiz_list.reduce((list, phiz) => {
                list[phiz.type] = list[phiz.type] || [];
                list[phiz.type].push(phiz);
                return list;
              }, {});
            }
            acc["I" + m_type].push({ ...rest, m_type });
          }
          return acc;
        }, {});
        // 提取场景配置
        let scenes = res.data.scenes.reduce((acc, item) => {
          const { position, ...rest } = item;
          acc[position] = acc[position] || [];
          acc[position].push({ ...rest, position });
          return acc;
        }, {});
        commit("setOutfitConfig", {
          models,
          scenes,
        });
      }
      return res;
    },
    // AI模特创建
    async postTaskSubmit({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/fashionlabs/task/submit", data);
      return res;
    },
    // 查询单个商品价格
    async getGoodsPrice({ commit }, data) {
      console.log(commit);
      const res = await axios.post("v1/product/detail", data);
      return res;
    },
    // 场景列表
    async getSceneList({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/fashionlabs/getscenelist", {
        params: data,
      });
      return res;
    },
    // 模型比例列表接口
    async getModelScaleList({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/stablediffusion/getmodelscalelist");
      return res;
    },
    // 模型场景列表接口
    async getModelSceneList({ commit }, data) {
      console.log(commit);
      const res = await axios.post(
        "/v1/stablediffusion/getmodelscenelist",
        data
      );
      return res;
    },
    // 商品任务制作接口
    async getCommodityCreate({ commit }, data) {
      console.log(commit);
      const res = await axios.post(
        "/v1/stablediffusion/commodity_create",
        data
      );
      return res;
    },
  },
  getters: {},
};
